module.exports = __webpack_public_path__ + "static/media/default-beer-image.4b744a54.jpg";